angular.module("vgresiduos").controller("DisposalCostPopupCtrl", [
	"$scope",
	"dialogService",
	"disposalId",
	function ($scope, dialogService, disposalId) {
		"use strict";
		$scope.disposalId = disposalId;
		$scope.queries = [{ label: "dialog", value: "cost" }];

		$scope.$on(Vgr.constants.evtIframeOnCancelDisposalDialogPagePopUp, function (event, data) {
			dialogService.hide($scope.dialog);
		});

		$scope.$on(Vgr.constants.evtIframeOnSuccessCostDisposalDialogPagePopUp, function (event, data) {
			dialogService.hide($scope.dialog);
			window.location.reload();
		});

		$scope.$on(Vgr.constants.evtIframeHeight, function (event, data) {
			const dialog = document.getElementsByTagName("md-dialog")[0];
			if (dialog) {
				dialog.style.height = window.innerHeight + "px";
			}
		});
	}
]);
